module.exports = __webpack_public_path__ + "img/telegramLight.bf8d16b9.svg";